// 27 областей для поля «Область»: 24 области, Крым и два города со своим статусом. Названия
// по-украински, как в официальном классификаторе (КАТОТТГ), из которого берутся районы и
// населённые пункты (districts.js, data/settlements.json): так область, район и населённый пункт
// в базе записаны одинаково. Подписи на экране остаются русскими.
export const OBLASTS = [
  'Вінницька',
  'Волинська',
  'Дніпропетровська',
  'Донецька',
  'Житомирська',
  'Закарпатська',
  'Запорізька',
  'Івано-Франківська',
  'Київська',
  'Кіровоградська',
  'Луганська',
  'Львівська',
  'Миколаївська',
  'Одеська',
  'Полтавська',
  'Рівненська',
  'Сумська',
  'Тернопільська',
  'Харківська',
  'Херсонська',
  'Хмельницька',
  'Черкаська',
  'Чернівецька',
  'Чернігівська',
  'Автономна Республіка Крим',
  'м. Київ',
  'м. Севастополь',
];

// Список для выпадающего поля. Старое значение компании, которого нет в списке («Україна» у
// компаний из первой загрузки базы, область по-русски у тех, кого ещё не перевели), остаётся в нём
// первым: пока форму правят, значение не пропадает само, а человек видит, что его можно заменить.
export const oblastOptions = (value) => (value && !OBLASTS.includes(value) ? [value, ...OBLASTS] : OBLASTS);
